import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Paintbrush, Rocket } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <MessageCircle size={40} className="text-nova-accent" data-id="element-211" />,
    title: 'NOS CONTACTAS',
    description: 'Escríbenos por WhatsApp al 3508108717. Cuéntanos sobre tu negocio en 5 minutos.'
  }, {
    icon: <Paintbrush size={40} className="text-nova-accent" data-id="element-212" />,
    title: 'DISEÑAMOS TU PÁGINA',
    description: 'Creamos el diseño personalizado para tu negocio y tu marca.'
  }, {
    icon: <Rocket size={40} className="text-nova-accent" data-id="element-213" />,
    title: 'LANZAMOS Y LISTO',
    description: 'Tu página está online y trabajando para conseguirte clientes 24/7.'
  }];
  return <section className="py-32 bg-nova-bg relative overflow-hidden" data-id="element-214">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-215">
        <img src="https://cdn.magicpatterns.com/uploads/28wy3Z1ZKDr63CQHfjnAEp/Ultra-realistic_abstract_techn_Nano_Banana_2_45442.png" alt="Abstract Tech Background" className="w-full h-full object-cover opacity-10 mix-blend-screen" data-id="element-216" />
        <div className="absolute inset-0 bg-gradient-to-b from-nova-bg via-transparent to-nova-bg" data-id="element-217" />
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-bold text-nova-text" data-id="element-220">
            Tu Página Web Lista en{' '}
            <span className="text-nova-accent" data-id="element-221">3 Pasos Simples</span>
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-4" data-id="element-222" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-223">
          {/* Connector Line (Desktop only) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-nova-card" data-id="element-224">
            <div className="absolute inset-0 bg-nova-accent/30" data-id="element-225" />
          </div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center" data-id="element-226">
              <div className="w-24 h-24 rounded-full bg-nova-card border-2 border-nova-accent/20 flex items-center justify-center mb-6 relative z-10 shadow-lg shadow-nova-accent/5" data-id="element-227">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-nova-text mb-3" data-id="element-228">
                {step.title}
              </h3>
              <p className="text-nova-text-muted" data-id="element-229">{step.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}